import "./StepHeader.css";

const StepHeader = ({ number, title, subtitle }) => {
    return (
        <div className="step-header">

            {number && <div className="step-circle">
                {number}
            </div>}

            <div className="step-text">

                <h3>{title}</h3>

                {subtitle && (
                    <p>{subtitle}</p>
                )}

            </div>

        </div>
    );
};

export default StepHeader;